// ─────────────────────────────────────────
//  i18n
// ─────────────────────────────────────────
const T = {
  en: {
    appTitle: "Team-Based Learning · tRAT", appSub: "Digital Scratch Cards",
    forTeachers: "For teachers", forStudents: "For students",
    joinAsStudent: "Join as student",
    haveDashboardCode: "Do you have a dashboard code?",
    noAccount: "No account?", createAccount: "Create one",
    signUp: "Create account", signUpSub: "Set up a teacher account.",
    alreadyHaveAccount: "Already have an account?", signInLink: "Sign in",
    signUpButton: "Create account →", signUpSuccess: "Check your email to confirm your account.",
    signInWithLU: "Sign in with LU account",
    createSession: "Create new tRAT", joinSession: "Join tRAT",
    enterSessionCode: "tRAT code", enterDashCode: "Enter dashboard code",
    join: "Join →", start: "Start →", view: "View →", back: "← Back", loading: "Loading…",
    sessionNotFound: "tRAT not found. Check the code and try again.", dashNotFound: "Dashboard not found.",
    groupName: "Your group name", groupPlaceholder: "e.g. Group 3 or Team Alpha",
    createNewGroup: "Create new group", joinExistingGroup: "Join existing group",
    existingGroups: "Active groups", orJoinExisting: "Or join an existing group:",
    createSessionTitle: "Create tRAT", createSessionSub: "Set answer key — groups will never see this.",
    numQuestions: "Number of questions", numOptions: "Answer options", answerKey: "Answer key",
    optionalQuestions: "Question texts (optional)", optionalQuestionsHint: "Students will see these during the tRAT.",
    questionText: "Question", rationaleText: "Rationale for correct answer",
    generateCodes: "Save and show codes →", creating: "Creating…", cancel: "Cancel",
    sessionReady: "tRAT ready!", shareWithGroups: "Share with groups",
    sessionCodeHint: "Groups enter this code to join.",
    sessionCodeHintPredefined: "Groups enter this code to join. It is already printed on the code sheets, so with pre-created groups you don't need to share it separately.", dashCodeLabel: "Your dashboard code (keep private)",
    dashCodeHint: "Enter this to view results.", openDashboard: "Open dashboard →",
    createAnother: "Create another tRAT", copy: "Copy", copied: "Copied ✓",
    score: "Score", seeResults: "See results →", outOf: "out of", points: "points",
    firstTry: "1st try", secondTry: "2nd try", thirdTry: "3rd try", fourthMiss: "4th / miss",
    backToCards: "← Back to the questions", showQuestion: "▼ Show question", hideQuestion: "▲ Hide question",
    groupScores: "Group scores", noGroupsYet: "No groups have completed the session yet. Auto-refreshing…",
    questionAnalysis: "Question analysis", questionAnalysisSub: "Questions where groups struggled are highlighted.",
    showQuestions: "Show questions", questionsTitle: "Questions",
    showKey: "Show answer key", hideKey: "Hide answer key", correctOption: "Correct answer",
    previewShuffleNote: "Groups see the questions and options in their own order. This is the standard order — the same numbering as in question analysis and appeals.",
    previewPaperOnly: "This question exists only on paper.",
    previewNoQuestions: "This tRAT has only an answer key — the questions are on paper.",
    avgScore: "Avg score", firstTryPct: "1st try %", correctAns: "Correct ans.",
    refresh: "↻ Refresh", lastUpdated: "Last updated", autoRefresh: "Updates live",
    exportCSV: "Export CSV", qrCode: "QR Code", totalScore: "Total",
    appeals: "Appeals", appealTitle: "Appeal a question",
    appealSub: "Appeals are granted when you show that you understood the concept but missed the question due to ambiguities in the question wording or the preparation material.",
    iFATQuestion: "IFAT question / row number", proposedAnswer: "Proposed correct answer",
    impactQuestion: "How did the ambiguity affect the team's decision?",
    reasoningQuestion: "What knowledge or reasoning made the team's answer seem like a more reasonable choice than the intended correct answer?",
    ambiguitySource: "Which part of the question did the team find unclear?",
    rewriteQuestion: "Rewrite the question or the relevant part so the ambiguity is reduced without giving away the answer.",
    whyDisagree: "Explain why you disagree with the given correct answer.",
    materialReference: "Specific references from the preparation material that support your argument.",
    appealSelectQuestion: "Which question does your appeal concern?",
    whyBest: "Argue why your chosen answer is the best or should be accepted as correct.",
    submitGreen: "Submit green appeal", submitYellow: "Submit yellow appeal",
    noAppeals: "No appeals submitted yet.",
    approve: "Approve…", reject: "Reject…",
    appealGroupAnswers: "The group answered", appealNotAnswered: "has not answered this question", appealRightShort: "correct", appealWrongShort: "wrong",
    appealCurrentScore: "{n} p now", appealNewScore: "New score for the question", appealDeduction: "Deduction",
    appealSuggestion: "suggested: {label} was scratched as no. {n} → {p} p", appealScoreAfter: "{n} p after the deduction",
    appealConfirmApprove: "Approve", appealConfirmReject: "Reject",
    appealApproved: "Approved", appealRejected: "Rejected",
    greenAppealShort: "Ambiguity in the question", yellowAppealShort: "Content problem in the question",
    appealAlreadySubmitted: "You have already submitted this type of appeal for this question.",
    appealSubmittedConfirm: "An appeal has been submitted.",
    submitAnotherAppeal: "Submit another appeal",
    submittedAppealsLabel: "Submitted appeals",
    noSubmittedAppeals: "No appeals submitted yet.",
    appealSubmitted: "Submitted!", savePoints: "Save",
    burningQuestions: "Burning Questions",
    burningQuestionsDesc: "We want to hear how another team reasoned about:",
    bqOptWhyCorrect: "Why the correct answer is best",
    bqOptWhyOurs: "Why our option is not best",
    bqOptDifference: "The difference between two options",
    bqOptConcept: "A term or concept in the question",
    bqOptOther: "Other",
    bqShortDesc: "Comment",
    bqRequired: "Tick at least one option and write a comment.",
    burningQPlaceholder: "This is how we reasoned…",
    submitBQ: "Submit burning question", bqSubmitted: "Question submitted!",
    bqAlready: "Your burning question for this question has been sent.",
    bqLabel: "Burning Questions", noBQ: "No burning questions submitted yet.",
    delegate: "Delegate to group", delegateTo: "Delegate to:", delegated: "Delegated →",
    correctGroups: "Groups with full points:",
    noFullScoreGroups: "No group got full points on this question — nothing to delegate.",
    delegationReceived: "Burning question delegated to you!",
    yourAnswer: "Your group's answer", submitDelegationAnswer: "Submit answer",
    delegationAnswerSubmitted: "Answer submitted!",
    delegationAnswerPlaceholder: "Explain the concept or why this answer is correct…",
    delegationAnswers: "Delegation answers", noDelegations: "No delegations sent yet.",
    bqAnsweredBy: "Answered by", bqAwaitingAnswer: "Awaiting answer from", bqDelegatedTo: "Delegated to",
    itemDiscrimination: "Item disc.", discGood: "Good", discFair: "Fair", discPoor: "Poor", questionText: "Question",
    continueWithGoogle: "Continue with Google", orDivider: "or",
    signIn: "Teacher sign in", signInSub: "Sign in to create and manage tRATs.",
    signOut: "Sign out", mySessions: "My tRATs",
    continueAsGuest: "Continue without account", guestWarningTitle: "No account — save your codes!",
    guestWarning: "Without an account your tRATs are not saved. Make sure to copy both the tRAT code and the dashboard code before leaving this page.",
    showRationale: "Show rationale to students", rationaleVisible: "Rationale visible",
    rationale: "💡 Rationale", darkMode: "Dark", lightMode: "Light",
    language: "Svenska", groupsCompleted: "groups completed", sessionInfo: "tRAT",
    resuming: "Resuming your tRAT…",
    liveLeaderboard: "Live Leaderboard", leaderboardCodeLabel: "Leaderboard URL",
    leaderboardCodeHint: "Share this URL to display live scores on a projector or screen.",
    openLeaderboard: "Open leaderboard →", rank: "Rank", group: "Group",
    updatingLive: "Updating live…", noScoresYet: "No scores yet — waiting for groups to start…",
    appealLabelAmbiguity: "Unclear part", appealLabelRewrite: "Rewrite",
    appealLabelImpact: "Impact", appealLabelReasoning: "Reasoning",
    appealLabelProposed: "Proposed", appealLabelDisagreement: "Disagreement",
    appealLabelReferences: "References", appealLabelWhyBest: "Why best",
    tableGroup: "Group", tableAverage: "Average", delegationFrom: "From",
    delegationAwaiting: "Awaiting answer from",
    lockSession: "End tRAT", unlockSession: "Reopen tRAT",
    endTratConfirm: "End the tRAT? Groups can no longer answer, join, or submit appeals and burning questions. You can reopen it afterwards.",
    endTratConfirmBtn: "End tRAT",
    sessionLocked: "tRAT ended", sessionLockedMsg: "The teacher has ended this tRAT. No new answers or appeals can be submitted.",
    sessionLockedJoin: "This tRAT has ended and is no longer accepting new groups.",
    sessionTitle: "tRAT title", sessionTitlePlaceholder: "e.g. Week 3 - Cell Biology",
    saveAsTemplate: "Save as template", duplicate: "Duplicate", delete: "Delete",
    confirmDelete: "Are you sure you want to delete this tRAT? This cannot be undone.",
    sessionDeleted: "tRAT deleted", showQR: "Show QR code", 
    editTitle: "Edit title", sessionSchedule: "Time & availability", scheduleFor: "Start date & time",
    makeAvailableNow: "Available immediately", makeAvailableAt: "Scheduled start",
    sessionDurationLabel: "Max duration (optional)", sessionDurationHint: "min — timer starts automatically when the session opens", sessionDurationNone: "No time limit",
    groupModeFree: "Participants create their own groups", groupModePredefined: "Pre-created groups",
    groupModePredefinedDesc: "Each group gets a join code",
    groupModePredefinedTip: "You name the groups in advance. Each group gets its own join code that you hand out — no one can join under another group's name.",
    groupModeFreeDesc: "No join code needed",
    groupModeFreeTip: "Students pick a group name themselves when joining. No code needed — anyone with the tRAT code can start a group.",
    groupsRequired: "Pre-created groups is selected, but no groups are listed. Add at least one group, or switch to students creating their own groups.",
    groupNameTooLong: name => `The group name "${name.slice(0, 40)}…" is longer than 80 characters. Shorten it — students cannot join with a longer name.`,
    saveFailed: "The changes could not be saved. Check your connection and try again — if it keeps failing, reload the page and log in again.",
    questionsTab: "Questions & answer key",
    reimportBar: "Questions and answer key below. Import a QPS report, your own question document, Excel file or text to replace them.",
    importParseText: "Read text",
    qChooseTitle: "Where do the questions come from?",
    qChooseImport: "Import questions", qChooseImportDesc: "PDF, Word, Excel or the question bank",
    qChooseWrite: "Write the questions here", qChooseWriteDesc: "One question at a time",
    writeBar: "Write the questions below and click a letter to mark the correct answer. You can also import from a file.",
    qChooseManual: "Answer key only", qChooseManualDesc: "The questions are handed out on paper; you only enter the correct answers",
    reimportBarImported: "{n} imported questions. Edit below, or import a new file to replace them.",
    backToQuestions: "← Back to the questions", removeQuestion: "Remove", addQuestion: "+ Add question",
    groupGenCount: "Number of groups", groupGenPrefix: "Name prefix", groupGenAdd: "Add groups",
    answerKeyOrImport: "Fill in the answer key by hand below, or read the questions straight out of a QPS report, your own question document, Excel file or text.",
    goToImport: "Import questions →",
    nextImportQuestions: "Next: questions →",
    skipImport: "Skip import — fill in the answer key by hand →",
    randomizeLabel: "Random order",
    randomizeQuestions: "Shuffle question order",
    randomizeQuestionsDesc: "Each group gets the questions in its own order. Note that during the tRAT, \"question 3\" then means different things to you and to the group.",
    randomizeOptions: "Shuffle answer options",
    randomizeOptionsDesc: "The options are reordered within each question, per group. Question numbering stays the same for everyone.",
    randomizeHint: "Off by default. The order is drawn per group — not per device — so everyone in a group sees the same thing. It is drawn when the group first joins, so groups that have already joined keep their order if you change the setting. Only what appears as text in the app is shuffled: if the questions are on paper, they and their letters keep their order so the sheet still matches. Once the tRAT is finished, everyone sees the standard order again, so appeals and burning questions refer to the same question for all.",
    groupCodeLabel: "Group code", groupCodePlaceholder: "4-digit code",
    groupCodeError: "Incorrect code. Try again.",
    groupCodeHint: "Enter the 4-digit code you received for your group.",
    downloadCodeSheet: "Print code sheet",
    groupCodesTitle: "Group codes",
    groupCodesDesc: "Each group needs their unique code to join. Hand these out before the session.",
    groupCodesNewBadge: "new code on save",
    groupCodesRemovedBadge: "removed on save",
    groupCodesPending: "Unsaved group changes. Save to give the new groups a code — the groups that stay keep theirs.",
    groupCodesSaved: "Groups saved. The code sheet below is up to date.",
    downloadCodeSheetNew: "Print sheet for new groups only",
    sessionNotYetAvailable: "This tRAT is not yet available. It will open at:",
    scheduledFor: "Scheduled for", viewEdit: "View/Edit",
    tabOverview: "Overview", tabAnswerKey: "Answer Key", tabQuestions: "Questions", settingsTab: "Settings",
    tabReimport: "Re-import",
    reimportWarningWizard: "Replaces all {n} questions and the whole answer key. Nothing is saved until you click Save and show codes.",
    reimportWarning: "Replaces all {n} questions and the whole answer key in this tRAT. No group has started, so no results are affected. Nothing is written until you click Save changes.",
    reimportPending: "New questions loaded — click Save changes to overwrite the tRAT. Close without saving to undo.",
    importTab: "Import",
    importTitle: "Import questions",
    importSubtitle: "From a QPS report (Orzone), your own Word or PDF document, or an Excel file",
    importMethodPDF: "PDF",
    importMethodText: "Text",
    importMethodExcel: "Excel",
    importPDFDesc: "QPS report or your own document with an answer key",
    importTextDesc: "Paste questions from Word, Google Docs or a PDF",
    importExcelDesc: "One question per row, from the template (.xlsx)",
    importDragDrop: "Drag file here or click to select",
    importPasteHere: "Question 1\nWhich drug is first-line for tularemia?\nA. Clindamycin\nB. Cefadroxil\nC. Ciprofloxacin\nD. Amoxicillin\nExplanation: … (optional)\n\nQuestion 2\n…\n\nAnswer key\n1. C\n2. A",
    importParsing: "Reading file...",
    importParse: "Read file",
    importSuccess: "✓ {count} questions found",
    importError: "Could not parse file. Check format and try again.",
    importPreview: "Preview questions",
    importConfirm: "Import {count} questions",
    importCancel: "Cancel",
    importQuestionPreview: "Question {num}",
    importCorrectAnswer: "Correct: {answer}",
    importValidationError: "Validation errors:",
    importFileTooLarge: "File too large. Maximum size is 10MB.",
    importNoQuestions: "No questions found. Each question needs a heading (\"Question 1\" or \"1.\"), the question text and options starting with A., B., C. … Give the correct answers in an answer key at the end (\"Answer key\" followed by \"1. B\"), as \"Answer: B\" under the question, or with * after the correct option.",
    importMissingAnswers: "The correct answer is missing for question {list}. Click the correct option in the preview below.",
    importPickHint: "Click an option to make it the correct answer.",
    importNoAnswer: "Correct answer missing — click an option",
    importMethodDoc: "PDF or Word",
    importDocDesc: "QPS report or your own question document (.pdf, .docx)",
    importDragDropDoc: "Drag a PDF or Word file here, or click to choose",
    importDragDropExcel: "Drag an Excel file here, or click to choose",
    importDocFormatTitle: "What your own document should look like",
    importDocExample: "Question 1\nWhich drug is first-line for tularemia?\nA. Clindamycin\nB. Cefadroxil\nC. Ciprofloxacin\nD. Amoxicillin\nExplanation: … (optional)\n\nQuestion 2\n…\n\nAnswer key\n1. C\n2. …",
    importDocHint: "QPS reports are read as they are. Options can be typed (A., B., …) or made with a numbered list in Word. The correct answer can also be given as \"Answer: B\" under the question.",
    importDownloadWordTemplate: "Download Word template",
    importExcelFormatTitle: "What the Excel file should look like",
    importExcelHint: "One question per row, headings on the first row. Add columns E and F for more options. The explanation is optional.",
    importDownloadExcelTemplate: "Download Excel template",
    importOrPaste: "Or paste text (e.g. from Google Docs)",
    importOldWord: "Old Word files (.doc) can't be read. Open the file in Word and save it as .docx.",
    myAnswers: "Group's answers", showGroupAnswers: "Show the group's answers",
    tratCode: "tRAT code", dashboardLink: "Dashboard", leaderboardLink: "Leaderboard",
    groupsStarted: "groups started", noGroupsStarted: "No groups started yet",
    // Home screen
    homeTagline: "Digital tool for the tRAT phase – students scratch together, teachers follow results in real time.",
    forStudentsCard: "Have you received a code from your teacher? Enter it here.",
    forTeachersCard: "Create digital scratch cards and see results live.",
    howItWorks: "How it works",
    step1Title: "Create", step1Text: "Teacher creates a tRAT round and gets a code.",
    step2Title: "Join", step2Text: "Students enter with the code and answer together.",
    step3Title: "Follow", step3Text: "Monitor team progress live.",
    contactSupport: "Support & contact",
    whatIsTRAT: "What is tRAT?",
    whatIsTRATTitle: "What is tRAT?",
    whatIsTRATText: "tRAT (Team Readiness Assurance Test) is part of Team-Based Learning (TBL) where student groups solve multiple-choice questions together by \"scratching\" digital lottery cards.\n\nEach group gets:\n• Up to 4 attempts per question\n• Points based on number of attempts\n• Immediate feedback after each attempt\n\nPerfect for:\n✓ Activating students\n✓ Promoting teamwork\n✓ Providing immediate feedback\n✓ Following results in real time",
    helpModalWhat: "What is tRAT?",
    helpModalHow: "How does it work?",
    helpModalFAQ: "FAQ",
    howItWorksTeacher: "For teachers:",
    howItWorksStudent: "For students:",
    howTeacherStep1: "Click \"Create new tRAT\"",
    howTeacherStep2: "Fill in questions and answer key",
    howTeacherStep2Sub: "Or import from PDF (QPS or your own document)",
    howTeacherStep3: "Share the code with students",
    howTeacherStep4: "Follow results live in Dashboard",
    howStudentStep1: "Enter the code from your teacher",
    howStudentStep2: "Create group or join existing one",
    howStudentStep3: "Answer questions together",
    howStudentStep4: "Each attempt gives points!",
    howStudentStep4Sub: "4p → 2p → 1p → 0p",
    helpStudentIntro: "You answer together as a group. Discuss before you scratch.",
    helpStudentSteps: [
      "Everyone in the group can follow along on their own device, or you can share one. Join the same group name and you see the same cards.",
      "Scratch the option the group agrees on. Correct on the first try gives 4 points, then 2, 1 and 0 for each new attempt. A scratched answer cannot be undone.",
      "You set the pace. The next question appears when you click on.",
      "If the teacher has started a timer it is shown at the top. When time runs out your answers are submitted as they are.",
      "When all questions are done you see your result. There you can appeal a question or send a burning question to the teacher.",
      "If something gets stuck, reload the page. Your answers are saved on the server and will still be there.",
    ],
    timerLabel: "Timer", timerStart: "Start", timerStop: "Stop", timerReset: "Reset",
    timerMinutes: "min", timerDone: "Time's up!",
    predefinedGroups: "Groups", predefinedGroupsHint: "Enter one group name per line. Students will see these as options when joining.",
    predefinedGroupsPlaceholder: "Group 1\nGroup 2\nGroup 3",
    shareSession: "Share session", groupsCompleted2: "groups done", avgScore2: "avg",
    sessionStats: "No groups yet",
    howItWorksTitle: "How it works",
    howItWorksText: "1. Teacher creates a tRAT\nSign in and set up a round: choose the number of questions, answer options and enter the answer key. You get a unique tRAT code to share with students and a private dashboard code to monitor results.\n\n2. Students join in groups\nEach group enters the tRAT code and picks a group name. Everyone participates on their own device — no app needed, just a browser.\n\n3. The group scratches the cards\nQuestions appear one at a time. The group discusses and selects an answer by \"scratching\" an option. Correct on the first try = full points. Wrong = one more try, with a point deduction per attempt.\n\n4. Teacher follows in real time\nThe dashboard shows which groups have finished, score distribution, and which questions were hard — updated automatically every few seconds.\n\n5. Discussion and follow-up\nGroups can submit appeals and burning questions — things they're still unsure about — which can be discussed with the whole class afterwards.",
    // Question bank screen
    qbTitle: "Question bank",
    qbSubtitle: "Reusable multiple-choice questions you can import into a tRAT.",
    qbTag: "Tag",
    qbNewQuestion: "New question",
    qbSearchPlaceholder: "Search questions…",
    qbFilterAllScopes: "All visibilities",
    qbFilterPrivate: "Private",
    qbFilterCourse: "Course",
    qbFilterProgram: "Program",
    qbFilterOrg: "Organisation",
    qbAllTags: "All",
    qbEmpty: "The question bank is empty.",
    qbEmptyHint: "Create your first question or save questions from a tRAT.",
    qbNoMatch: "No questions match the filter.",
    qbNoQuestionText: "No question text",
    qbEdit: "Edit",
    qbRationale: "Rationale",
    qbTags: "Tags",
    qbNoTagsYet: "No tags yet. Create one via \"+ Tag\".",
    qbScopePrivate: "Private",
    qbScopeCourse: "Course",
    qbScopeProgram: "Program",
    qbScopeOrg: "Organisation",
    qbScopePrivateOnlyMe: "Private – only me",
    qbEditQuestion: "Edit question",
    qbQuestionTextLabel: "Question text",
    qbQuestionTextPlaceholder: "Write the question here…",
    qbOptionsLabel: "Answer options",
    qbSetAsCorrect: "Set as correct answer",
    qbOptionPlaceholder: "Option {label}",
    qbCorrectHint: "Click the letter to mark the correct answer.",
    qbRationaleOptional: "Rationale (optional)",
    qbRationalePlaceholder: "Explanation of the correct answer…",
    qbVisibility: "Visibility",
    qbCourseLabel: "Course",
    qbSelectCourse: "Choose course…",
    qbSaving: "Saving…",
    qbSaveChanges: "Save changes",
    qbSaveQuestion: "Save question",
    qbNewTag: "New tag",
    qbTagNameLabel: "Name",
    qbTagNamePlaceholder: "e.g. Anatomy",
    qbTagPreview: "Preview",
    qbTagPrivateHint: "Tags are personal \u2014 only you see the ones you create.",
    qbCreateTag: "Create tag",
    qbErrNoText: "Question text is required.",
    qbErrNoCorrect: "Specify the correct answer.",
    qbErrSave: "Error while saving.",
    qbQuestionUpdated: "Question updated!",
    qbQuestionSaved: "Question saved!",
    qbConfirmDelete: "Delete the question? This cannot be undone.",
    qbQuestionDeleted: "Question deleted.",
    qbTagCreated: "Tag created!",
    qbDeleteQuestionAria: "Delete question",
  },
  sv: {
    appTitle: "Team-Based Learning · tRAT", appSub: "Digitala skraplotter",
    forTeachers: "För lärare", forStudents: "För studenter",
    joinAsStudent: "Delta som student",
    haveDashboardCode: "Har du en dashboardkod?",
    noAccount: "Inget konto?", createAccount: "Skapa ett",
    signUp: "Skapa konto", signUpSub: "Skapa ett lärarkonto.",
    alreadyHaveAccount: "Har du redan ett konto?", signInLink: "Logga in",
    signUpButton: "Skapa konto →", signUpSuccess: "Kolla din e-post för att bekräfta ditt konto.",
    signInWithLU: "Logga in med LU-konto",
    createSession: "Skapa ny tRAT", joinSession: "Gå med i tRAT",
    enterSessionCode: "tRAT-kod", enterDashCode: "Ange dashboardkod",
    join: "Gå med →", start: "Starta →", view: "Visa →", back: "← Tillbaka", loading: "Laddar…",
    sessionNotFound: "tRAT hittades inte. Kontrollera koden och försök igen.", dashNotFound: "Dashboard hittades inte.",
    groupName: "Ert gruppnamn", groupPlaceholder: "t.ex. Grupp 3 eller Team Alpha",
    createNewGroup: "Skapa ny grupp", joinExistingGroup: "Gå med i befintlig grupp",
    existingGroups: "Aktiva grupper", orJoinExisting: "Eller gå med i en befintlig grupp:",
    createSessionTitle: "Skapa tRAT", createSessionSub: "Ange facit — grupperna kommer aldrig se detta.",
    numQuestions: "Antal frågor", numOptions: "Svarsalternativ", answerKey: "Facit",
    optionalQuestions: "Frågetext (valfritt)", optionalQuestionsHint: "Studenterna ser dessa under tRAT:en.",
    questionText: "Fråga", rationaleText: "Återkoppling kring rätt svar",
    generateCodes: "Spara och visa koder →", creating: "Skapar…", cancel: "Avbryt",
    sessionReady: "tRAT:en är klar!", shareWithGroups: "Dela med grupperna",
    sessionCodeHint: "Grupperna anger denna kod för att gå med.",
    sessionCodeHintPredefined: "Grupperna anger denna kod för att gå med. Den står redan på kodbladen, så med förhandsskapade grupper behöver du inte dela den separat.", dashCodeLabel: "Din dashboardkod (håll privat)",
    dashCodeHint: "Ange denna för att se resultat.", openDashboard: "Öppna dashboard →",
    createAnother: "Skapa en annan tRAT", copy: "Kopiera", copied: "Kopierat ✓",
    score: "Poäng", seeResults: "Se resultat →", outOf: "av", points: "poäng",
    firstTry: "1:a försöket", secondTry: "2:a försöket", thirdTry: "3:e försöket", fourthMiss: "4:e / miss",
    backToCards: "← Tillbaka till frågorna", showQuestion: "▼ Visa fråga", hideQuestion: "▲ Dölj fråga",
    groupScores: "Grupppoäng", noGroupsYet: "Inga grupper har slutfört sessionen ännu. Uppdaterar automatiskt…",
    questionAnalysis: "Frågeanalys", questionAnalysisSub: "Frågor där grupper hade svårt är markerade.",
    showQuestions: "Visa frågor", questionsTitle: "Frågor",
    showKey: "Visa facit", hideKey: "Dölj facit", correctOption: "Rätt svar",
    previewShuffleNote: "Grupperna ser frågorna och alternativen i sin egen ordning. Här visas standardordningen — samma numrering som i Frågeanalys och appeals.",
    previewPaperOnly: "Frågan finns bara på papper.",
    previewNoQuestions: "Den här tRAT:en har bara facit — frågorna finns på papper.",
    avgScore: "Snittpoäng", firstTryPct: "1:a försök %", correctAns: "Rätt svar",
    refresh: "↻ Uppdatera", lastUpdated: "Senast uppdaterad", autoRefresh: "Uppdateras live",
    exportCSV: "Exportera CSV", qrCode: "QR-kod", totalScore: "Totalt",
    appeals: "Appeals", appealTitle: "Appeals",
    appealSub: "Appeals beviljas när ni visar att ni förstått konceptet men missade frågan på grund av tvetydigheter i frågeformuleringen eller förberedelsematerialet.",
    iFATQuestion: "IF-AT fråga/rad nr", proposedAnswer: "Föreslaget korrekt svar",
    impactQuestion: "Hur påverkade otydligheten teamets beslut?",
    reasoningQuestion: "Vilken kunskap eller resonemang gjorde att teamets svar framstod som ett rimligare val än det tänkta korrekta svaret?",
    ambiguitySource: "Vilken del av frågan uppfattade teamet som otydlig?",
    rewriteQuestion: "Skriv om frågan eller den relevanta delen så att tvetydigheten minskar utan att frågan avslöjar svaret.",
    whyDisagree: "Ange varför ni inte håller med om det angivna korrekta svaret.",
    materialReference: "Specifika referenser från förberedelsematerialet som stödjer ert argument.",
    appealSelectQuestion: "Vilken fråga gäller er appeal?",
    whyBest: "Argumentera för varför det valda svaret är det bästa eller bör godtas som korrekt.",
    submitGreen: "Lämna in appeal", submitYellow: "Lämna in appeal",
    noAppeals: "Inga appeals har lämnats in ännu.",
    approve: "Godkänn…", reject: "Avslå…",
    appealGroupAnswers: "Gruppen svarade", appealNotAnswered: "har inte svarat på frågan", appealRightShort: "rätt", appealWrongShort: "fel",
    appealCurrentScore: "{n} p nu", appealNewScore: "Ny poäng för frågan", appealDeduction: "Avdrag",
    appealSuggestion: "förslag: {label} skrapades som nr {n} → {p} p", appealScoreAfter: "{n} p efter avdraget",
    appealConfirmApprove: "Godkänn", appealConfirmReject: "Avslå",
    appealApproved: "Godkänd", appealRejected: "Avslagen",
    greenAppealShort: "Tvetydighet i frågan", yellowAppealShort: "Innehållsproblem i frågan",
    appealAlreadySubmitted: "Ni har redan lämnat in denna typ av appeal för denna fråga.",
    appealSubmittedConfirm: "En appeal är inskickad.",
    submitAnotherAppeal: "Skicka in en till",
    submittedAppealsLabel: "Inskickade appeals",
    noSubmittedAppeals: "Inga appeals inskickade ännu.",
    appealSubmitted: "Inlämnat!", savePoints: "Spara",
    burningQuestions: "Burning Questions",
    burningQuestionsDesc: "Vi vill höra hur ett annat team resonerade kring:",
    bqOptWhyCorrect: "Varför det korrekta svaret är bäst",
    bqOptWhyOurs: "Varför vårt alternativ inte är bäst",
    bqOptDifference: "Skillnaden mellan två alternativ",
    bqOptConcept: "Ett begrepp eller koncept i frågan",
    bqOptOther: "Annat",
    bqShortDesc: "Kommentar",
    bqRequired: "Bocka i minst ett val och skriv en kommentar.",
    burningQPlaceholder: "Vi resonerade så här…",
    submitBQ: "Skicka in burning question", bqSubmitted: "Fråga inskickad!",
    bqAlready: "Er burning question för den här frågan är skickad.",
    bqLabel: "Burning Questions", noBQ: "Inga burning questions har skickats in ännu.",
    delegate: "Delegera till grupp", delegateTo: "Delegera till:", delegated: "Delegerad →",
    correctGroups: "Grupper med full poäng:",
    noFullScoreGroups: "Ingen grupp fick full poäng på frågan — inget att delegera.",
    delegationReceived: "En burning question har delegerats till er!",
    yourAnswer: "Er grupps svar", submitDelegationAnswer: "Skicka svar",
    delegationAnswerSubmitted: "Svar inskickat!",
    delegationAnswerPlaceholder: "Förklara konceptet eller varför detta svar är korrekt…",
    delegationAnswers: "Delegeringssvar", noDelegations: "Inga delegeringar har skickats ännu.",
    bqAnsweredBy: "Besvarad av", bqAwaitingAnswer: "Väntar på svar från", bqDelegatedTo: "Delegerad till",
    itemDiscrimination: "Diskr.", discGood: "Bra", discFair: "Godtagbar", discPoor: "Svag", questionText: "Fråga",
    continueWithGoogle: "Fortsätt med Google", orDivider: "eller",
    signIn: "Lärarinloggning", signInSub: "Logga in för att skapa och hantera tRATs.",
    signOut: "Logga ut", mySessions: "Mina tRAT:er",
    continueAsGuest: "Fortsätt utan konto", guestWarningTitle: "Inget konto — spara dina koder!",
    guestWarning: "Utan konto sparas inte dina tRATs. Se till att kopiera både tRAT-koden och dashboardkoden innan du lämnar sidan.",
    showRationale: "Aktivera återkoppling", rationaleVisible: "Återkoppling synlig",
    rationale: "💡 Återkoppling", darkMode: "Mörkt", lightMode: "Ljust",
    language: "English", groupsCompleted: "grupper klara", sessionInfo: "tRAT",
    resuming: "Återupptar din tRAT…",
    liveLeaderboard: "Live resultattavla", leaderboardCodeLabel: "Resultattavla URL",
    leaderboardCodeHint: "Dela denna URL för att visa live-poäng på projektor eller skärm.",
    openLeaderboard: "Öppna resultattavla →", rank: "Plats", group: "Grupp",
    updatingLive: "Uppdaterar live…", noScoresYet: "Inga poäng ännu — väntar på att grupper ska starta…",
    appealLabelAmbiguity: "Otydlig del", appealLabelRewrite: "Omformulering",
    appealLabelImpact: "Påverkan", appealLabelReasoning: "Resonemang",
    appealLabelProposed: "Föreslagen", appealLabelDisagreement: "Oenighet",
    appealLabelReferences: "Referenser", appealLabelWhyBest: "Varför bäst",
    tableGroup: "Grupp", tableAverage: "Medel", delegationFrom: "Från",
    delegationAwaiting: "Väntar på svar från",
    lockSession: "Avsluta tRAT", unlockSession: "Öppna igen",
    endTratConfirm: "Avsluta tRAT:en? Grupperna kan då inte längre svara, gå med, eller skicka appeals och burning questions. Du kan öppna den igen efteråt.",
    endTratConfirmBtn: "Avsluta tRAT",
    sessionLocked: "tRAT:en är avslutad", sessionLockedMsg: "Läraren har avslutat denna tRAT. Inga nya svar eller appeals kan skickas in.",
    sessionLockedJoin: "Denna tRAT är avslutad och tar inte emot nya grupper.",
    sessionTitle: "tRAT-titel", sessionTitlePlaceholder: "t.ex. Vecka 3 - Cellbiologi",
    saveAsTemplate: "Spara som mall", duplicate: "Duplicera", delete: "Radera",
    confirmDelete: "Är du säker på att du vill radera denna tRAT? Detta går inte att ångra.",
    sessionDeleted: "tRAT raderad", showQR: "Visa QR-kod",
    editTitle: "Redigera titel", sessionSchedule: "Tid och tillgänglighet", scheduleFor: "Startdatum & tid",
    makeAvailableNow: "Tillgänglig direkt", makeAvailableAt: "Schemalagd start",
    sessionDurationLabel: "Maxtid (valfritt)", sessionDurationHint: "min — timer startar automatiskt när sessionen öppnar", sessionDurationNone: "Ingen tidsgräns",
    groupModeFree: "Deltagare skapar egna grupper", groupModePredefined: "Förhandsskapade grupper",
    groupModePredefinedDesc: "Varje grupp får en inloggningskod",
    groupModePredefinedTip: "Du namnger grupperna i förväg. Varje grupp får en egen inloggningskod som du delar ut — ingen kan ansluta i en annan grupps namn.",
    groupModeFreeDesc: "Ingen inloggningskod behövs",
    groupModeFreeTip: "Studenterna väljer själva gruppnamn när de ansluter. Ingen kod behövs — den som har tRAT-koden kan starta en grupp.",
    groupsRequired: "Förhandsskapade grupper är valt, men inga grupper är angivna. Lägg till minst en grupp, eller byt till att deltagarna skapar egna grupper.",
    groupNameTooLong: name => `Gruppnamnet "${name.slice(0, 40)}…" är längre än 80 tecken. Korta det — med ett längre namn går det inte att ansluta.`,
    saveFailed: "Ändringarna kunde inte sparas. Kontrollera uppkopplingen och försök igen — fortsätter det, ladda om sidan och logga in igen.",
    questionsTab: "Frågor & facit",
    reimportBar: "Frågor och facit nedan. Importera en QPS-rapport, ett eget frågedokument, en Excel-fil eller text för att ersätta dem.",
    importParseText: "Tolka texten",
    qChooseTitle: "Var kommer frågorna ifrån?",
    qChooseImport: "Importera frågor", qChooseImportDesc: "PDF, Word, Excel eller frågebanken",
    qChooseWrite: "Skriv frågorna här", qChooseWriteDesc: "En fråga i taget",
    writeBar: "Skriv frågorna nedan och klicka på en bokstav för att markera rätt svar. Du kan också importera från en fil.",
    qChooseManual: "Bara facit", qChooseManualDesc: "Frågorna delas ut på papper, du anger bara rätt svar",
    reimportBarImported: "{n} importerade frågor. Redigera nedan, eller importera en ny fil för att ersätta dem.",
    backToQuestions: "← Tillbaka till frågorna", removeQuestion: "Ta bort", addQuestion: "+ Lägg till fråga",
    groupGenCount: "Antal grupper", groupGenPrefix: "Namnprefix", groupGenAdd: "Lägg till grupper",
    answerKeyOrImport: "Fyll i facit för hand nedan, eller läs in frågorna direkt ur en QPS-rapport, ett eget frågedokument, en Excel-fil eller text.",
    goToImport: "Importera frågor →",
    nextImportQuestions: "Nästa: frågor →",
    skipImport: "Hoppa över import — fyll i facit för hand →",
    randomizeLabel: "Slumpad ordning",
    randomizeQuestions: "Slumpa frågeordning",
    randomizeQuestionsDesc: "Varje grupp får frågorna i sin egen ordning. Tänk på att \"fråga 3\" under tiden betyder olika saker för dig och för gruppen.",
    randomizeOptions: "Slumpa svarsalternativ",
    randomizeOptionsDesc: "Alternativen kastas om inom varje fråga, per grupp. Frågenumreringen är densamma för alla.",
    randomizeHint: "Avstängt som standard. Ordningen lottas per grupp — inte per enhet — så alla i en grupp ser samma sak. Den lottas när gruppen ansluter första gången, så grupper som redan anslutit behåller sin ordning om du ändrar inställningen. Bara det som står som text i appen slumpas: står frågorna på papper behåller de och deras bokstäver sin ordning, så att bladet stämmer. När tRAT:en är genomförd visas standardordningen igen för alla, så att appeals och burning questions handlar om samma fråga för alla.",
    groupCodeLabel: "Gruppkod", groupCodePlaceholder: "4-siffrig kod",
    groupCodeError: "Felaktig kod. Försök igen.",
    groupCodeHint: "Ange den 4-siffriga koden ni fick för er grupp.",
    downloadCodeSheet: "Skriv ut kodblad",
    groupCodesTitle: "Gruppkoder",
    groupCodesDesc: "Varje grupp behöver sin unika kod för att gå med. Dela ut dessa innan sessionen.",
    groupCodesNewBadge: "ny kod vid spar",
    groupCodesRemovedBadge: "tas bort vid spar",
    groupCodesPending: "Osparade gruppändringar. Spara för att ge de nya grupperna en kod — grupperna som står kvar behåller sin.",
    groupCodesSaved: "Grupperna är sparade. Kodbladet nedan är uppdaterat.",
    downloadCodeSheetNew: "Skriv ut kodblad för de nya grupperna",
    sessionNotYetAvailable: "Denna tRAT är inte tillgänglig ännu. Den öppnar:",
    scheduledFor: "Schemalagd till", viewEdit: "Visa/Redigera",
    tabOverview: "Översikt", tabAnswerKey: "Facit", tabQuestions: "Frågor", settingsTab: "Inställningar",
    tabReimport: "Importera om",
    reimportWarningWizard: "Ersätter alla {n} frågor och hela facit. Inget sparas förrän du klickar Spara och visa koder.",
    reimportWarning: "Ersätter alla {n} frågor och hela facit i denna tRAT. Ingen grupp har startat, så inga resultat påverkas. Inget skrivs förrän du klickar Spara ändringar.",
    reimportPending: "Nya frågor inlästa — klicka Spara ändringar för att skriva över tRAT:en. Stäng utan att spara för att ångra.",
    importTab: "Importera",
    importTitle: "Importera frågor",
    importSubtitle: "Från en QPS-rapport (Orzone), ett eget Word- eller PDF-dokument eller en Excel-fil",
    importMethodPDF: "PDF",
    importMethodText: "Text",
    importMethodExcel: "Excel",
    importPDFDesc: "QPS-rapport eller eget dokument med facit",
    importTextDesc: "Klistra in frågor från Word, Google Docs eller en PDF",
    importExcelDesc: "En fråga per rad, enligt mallen (.xlsx)",
    importDragDrop: "Dra fil hit eller klicka för att välja",
    importPasteHere: "Fråga 1\nVilket läkemedel är förstahandsval vid tularemi?\nA. Klindamycin\nB. Cefadroxil\nC. Ciprofloxacin\nD. Amoxicillin\nFörklaring: … (valfritt)\n\nFråga 2\n…\n\nFacit\n1. C\n2. A",
    importParsing: "Tolkar filen...",
    importParse: "Tolka filen",
    importSuccess: "✓ {count} frågor hittade",
    importError: "Kunde inte parsa filen. Kontrollera formatet och försök igen.",
    importPreview: "Förhandsgranska frågor",
    importConfirm: "Importera {count} frågor",
    importCancel: "Avbryt",
    importQuestionPreview: "Fråga {num}",
    importCorrectAnswer: "Rätt: {answer}",
    importValidationError: "Valideringsfel:",
    importFileTooLarge: "Filen är för stor. Max storlek är 10MB.",
    importNoQuestions: "Hittade inga frågor. Varje fråga behöver en rubrik (”Fråga 1” eller ”1.”), frågetext och alternativ som börjar med A., B., C. … Ange rätt svar i ett facit sist (”Facit” följt av ”1. B”), som ”Rätt svar: B” under frågan eller med * efter rätt alternativ.",
    importMissingAnswers: "Rätt svar saknas för fråga {list}. Klicka på rätt alternativ i förhandsvisningen nedan.",
    importPickHint: "Klicka på ett alternativ för att göra det till rätt svar.",
    importNoAnswer: "Rätt svar saknas – klicka på ett alternativ",
    importMethodDoc: "PDF eller Word",
    importDocDesc: "QPS-rapport eller eget frågedokument (.pdf, .docx)",
    importDragDropDoc: "Dra en PDF- eller Word-fil hit, eller klicka för att välja",
    importDragDropExcel: "Dra en Excel-fil hit, eller klicka för att välja",
    importDocFormatTitle: "Så ska ett eget dokument se ut",
    importDocExample: "Fråga 1\nVilket läkemedel är förstahandsval vid tularemi?\nA. Klindamycin\nB. Cefadroxil\nC. Ciprofloxacin\nD. Amoxicillin\nFörklaring: … (valfritt)\n\nFråga 2\n…\n\nFacit\n1. C\n2. …",
    importDocHint: "QPS-rapporter läses som de är. Alternativen kan skrivas för hand (A., B., …) eller som en numrerad lista i Word. Rätt svar kan också anges som ”Rätt svar: B” under frågan.",
    importDownloadWordTemplate: "Ladda ner Word-mall",
    importExcelFormatTitle: "Så ska Excel-filen se ut",
    importExcelHint: "En fråga per rad, rubriker på första raden. Lägg till kolumnerna E och F för fler alternativ. Förklaringen är valfri.",
    importDownloadExcelTemplate: "Ladda ner Excel-mall",
    importOrPaste: "Eller klistra in text (t.ex. från Google Docs)",
    importOldWord: "Äldre Word-filer (.doc) går inte att läsa. Öppna filen i Word och spara den som .docx.",
    myAnswers: "Gruppens svar", showGroupAnswers: "Visa gruppens svar",
    tratCode: "tRAT-kod", dashboardLink: "Dashboard", leaderboardLink: "Resultattavla",
    groupsStarted: "grupper har börjat", noGroupsStarted: "Inga grupper har börjat ännu",
    // Home screen
    homeTagline: "Digitalt verktyg för tRAT-fasen i en TBL-modul – studenter skrapar tillsammans, lärare följer resultat i realtid.",
    forStudentsCard: "Har du fått en kod från din lärare? Skriv in den här.",
    forTeachersCard: "Skapa digitala skraplotter och följ arbetet live.",
    howItWorks: "Så går det till",
    step1Title: "Skapa", step1Text: "Läraren skapar en tRAT-omgång och får en kod.",
    step2Title: "Gå med", step2Text: "Studenter ansluter med koden och svarar tillsammans.",
    step3Title: "Följ arbetet", step3Text: "Läraren följer gruppernas arbete live.",
    contactSupport: "Support & kontakt",
    whatIsTRAT: "Vad är tRAT?",
    whatIsTRATTitle: "Vad är tRAT?",
    whatIsTRATText: "tRAT (Team Readiness Assurance Test) är en del av Team-Based Learning (TBL) där studentgrupper tillsammans löser flervalsuppgifter genom att \"skrapa\" digitala lotter.\n\nVarje grupp får:\n• Upp till 4 försök per fråga\n• Poäng baserat på antal försök\n• Direkt feedback efter varje försök\n\nPerfekt för att:\n✓ Aktivera studenter\n✓ Främja grupparbete\n✓ Ge omedelbar feedback\n✓ Följa resultat i realtid\n\nSå går det till:\n1️⃣ Skapa – Läraren skapar en tRAT och får en kod\n2️⃣ Gå med – Studenter använder koden för att delta\n3️⃣ Följ – Följ gruppernas arbete live.",
    helpModalWhat: "Vad är tRAT?",
    helpModalHow: "Hur fungerar verktyget?",
    helpModalFAQ: "Vanliga frågor",
    howItWorksTeacher: "För lärare:",
    howItWorksStudent: "För studenter:",
    howTeacherStep1: "Klicka \"Skapa ny tRAT\"",
    howTeacherStep2: "Fyll i frågor och facit",
    howTeacherStep2Sub: "Eller importera från PDF (QPS eller eget dokument)",
    howTeacherStep3: "Dela koden med studenterna",
    howTeacherStep4: "Följ resultat live i Dashboard",
    howStudentStep1: "Skriv in koden från läraren",
    howStudentStep2: "Skapa grupp eller gå med i befintlig",
    howStudentStep3: "Svara på frågorna tillsammans",
    howStudentStep4: "Varje försök ger poäng!",
    howStudentStep4Sub: "4p → 2p → 1p → 0p",
    helpStudentIntro: "Ni svarar tillsammans som grupp. Diskutera innan ni skrapar.",
    helpStudentSteps: [
      "Alla i gruppen kan följa med på sin egen enhet, eller så delar ni en. Gå med i samma gruppnamn så ser ni samma lotter.",
      "Skrapa det alternativ gruppen enas om. Rätt direkt ger 4 poäng, sedan 2, 1 och 0 för varje nytt försök. Ett skrapat svar kan inte ångras.",
      "Ni bestämmer tempot. Nästa fråga visas när ni klickar vidare.",
      "Har läraren startat en timer syns den överst. När tiden går ut lämnas era svar in som de är.",
      "När alla frågor är klara ser ni ert resultat. Där kan ni överklaga en fråga eller skicka en burning question till läraren.",
      "Hakar något upp sig: ladda om sidan. Era svar sparas på servern och finns kvar.",
    ],
    timerLabel: "Timer", timerStart: "Starta", timerStop: "Stoppa", timerReset: "Återställ",
    timerMinutes: "min", timerDone: "Tiden är ute!",
    predefinedGroups: "Grupper", predefinedGroupsHint: "Ange ett gruppnamn per rad. Studenterna ser dessa som alternativ när de ansluter.",
    predefinedGroupsPlaceholder: "Grupp 1\nGrupp 2\nGrupp 3",
    shareSession: "Dela session", groupsCompleted2: "grupper klara", avgScore2: "snitt",
    sessionStats: "Inga grupper ännu",
    howItWorksTitle: "Så funkar det",
    howItWorksText: "1. Läraren skapar en tRAT\nLogga in och skapa en omgång: välj antal frågor, svarsalternativ och ange facit. Du får en unik tRAT-kod att dela med studenterna och en privat dashboardkod för att följa resultaten.\n\n2. Studenterna går med i grupper\nVarje grupp anger tRAT-koden och väljer ett gruppnamn. Alla deltar via sina egna enheter — ingen app att installera, bara en webbläsare.\n\n3. Gruppen skrapar lottorna\nFrågorna visas en i taget. Gruppen diskuterar och väljer svar genom att \"skrapa\" ett alternativ. Rätt på första försöket ger full poäng. Fel svar ger ett nytt försök men med poängavdrag för varje försök.\n\n4. Läraren följer i realtid\nPå dashboarden visas vilka grupper som är klara, poängfördelning och vilka frågor som var svåra — uppdateras automatiskt var några sekunder.\n\n5. Diskussion och uppföljning\nGrupper kan skicka in appeals och burning questions — saker de fortfarande är osäkra på — som sedan kan diskuteras med hela klassen.",
    // Question bank screen
    qbTitle: "Frågebank",
    qbSubtitle: "Återanvändbara flervalsfrågor som du kan importera till en tRAT.",
    qbTag: "Tagg",
    qbNewQuestion: "Ny fråga",
    qbSearchPlaceholder: "Sök frågor…",
    qbFilterAllScopes: "Alla synligheter",
    qbFilterPrivate: "Privata",
    qbFilterCourse: "Kurs",
    qbFilterProgram: "Program",
    qbFilterOrg: "Organisation",
    qbAllTags: "Alla",
    qbEmpty: "Frågebanken är tom.",
    qbEmptyHint: "Skapa din första fråga eller spara frågor från en tRAT.",
    qbNoMatch: "Inga frågor matchar filtret.",
    qbNoQuestionText: "Ingen frågetext",
    qbEdit: "Redigera",
    qbRationale: "Motivering",
    qbTags: "Taggar",
    qbNoTagsYet: "Inga taggar ännu. Skapa via \"+ Tagg\".",
    qbScopePrivate: "Privat",
    qbScopeCourse: "Kurs",
    qbScopeProgram: "Program",
    qbScopeOrg: "Organisation",
    qbScopePrivateOnlyMe: "Privat – bara jag",
    qbEditQuestion: "Redigera fråga",
    qbQuestionTextLabel: "Frågetext",
    qbQuestionTextPlaceholder: "Skriv frågan här…",
    qbOptionsLabel: "Svarsalternativ",
    qbSetAsCorrect: "Sätt som rätt svar",
    qbOptionPlaceholder: "Alternativ {label}",
    qbCorrectHint: "Klicka på bokstaven för att markera rätt svar.",
    qbRationaleOptional: "Motivering (valfritt)",
    qbRationalePlaceholder: "Förklaring till rätt svar…",
    qbVisibility: "Synlighet",
    qbCourseLabel: "Kurs",
    qbSelectCourse: "Välj kurs…",
    qbSaving: "Sparar…",
    qbSaveChanges: "Spara ändringar",
    qbSaveQuestion: "Spara fråga",
    qbNewTag: "Ny tagg",
    qbTagNameLabel: "Namn",
    qbTagNamePlaceholder: "t.ex. Anatomi",
    qbTagPreview: "Förhandsgranskning",
    qbTagPrivateHint: "Taggar är personliga \u2014 bara du ser dem du skapar.",
    qbCreateTag: "Skapa tagg",
    qbErrNoText: "Frågetext krävs.",
    qbErrNoCorrect: "Ange rätt svar.",
    qbErrSave: "Fel vid sparande.",
    qbQuestionUpdated: "Fråga uppdaterad!",
    qbQuestionSaved: "Fråga sparad!",
    qbConfirmDelete: "Ta bort frågan? Det går inte att ångra.",
    qbQuestionDeleted: "Fråga borttagen.",
    qbTagCreated: "Tagg skapad!",
    qbDeleteQuestionAria: "Ta bort fråga",
  },
};

// FAQ data
const FAQ = {
  en: [
    {
      q: "How many questions should I have?",
      a: "Usually 10-20 questions. Minimum 5 to be meaningful, maximum 50. Most teachers use 15 questions."
    },
    {
      q: "Can I import questions from another system?",
      a: "Yes! You can import from PDF (QPS/Orzone), text (copy/paste from PDF), or Excel (.xlsx format)."
    },
    {
      q: "What happens if students have already started?",
      a: "Once the first group starts, you CANNOT change the answer key (to preserve fairness). You can still add question text and rationales."
    },
    {
      q: "How does the point system work?",
      a: "Correct on 1st attempt: 4 points • 2nd attempt: 2 points • 3rd attempt: 1 point • 4th attempt: 0 points (but they can continue)"
    },
    {
      q: "Can I schedule a tRAT for later?",
      a: "Yes! Under 'Settings' you can choose 'Scheduled start' and set a date/time when the tRAT becomes available."
    },
    {
      student: true,
      q: "What if students answer incorrectly?",
      a: "They can try again! Up to 4 attempts per question. Each wrong attempt gives fewer points when they finally answer correctly."
    },
    {
      student: true,
      q: "Can students see each other's answers?",
      a: "No, but they see whether the group answered correctly or incorrectly. That's why discussion before choosing is important!"
    },
    {
      student: true,
      q: "How long does a tRAT take?",
      a: "It depends on what the teacher sets. Some tRATs have time limits (e.g. 45 min), others have no time limit at all."
    },
    {
      student: true,
      q: "Which browsers work?",
      a: "Chrome, Firefox, Safari, Edge - all modern browsers. We recommend Chrome or Firefox for best experience."
    },
    {
      student: true,
      q: "Does it work on mobile?",
      a: "Yes! Both students and teachers can use mobile or tablet devices."
    }
  ],
  sv: [
    {
      q: "Hur många frågor ska jag ha?",
      a: "Vanligtvis 10-20 frågor. Minst 5 för att det ska vara meningsfullt, max 50. De flesta lärare använder 15 frågor."
    },
    {
      q: "Kan jag importera frågor från annat system?",
      a: "Ja! Du kan importera från PDF (QPS/Orzone), text (kopiera/klistra från PDF), eller Excel (.xlsx-format)."
    },
    {
      q: "Vad händer om studenter redan börjat?",
      a: "När första gruppen börjat kan du INTE ändra facit (för att bevara rättvisa). Du kan fortfarande lägga till frågetext och förklaringar."
    },
    {
      q: "Hur fungerar poängsystemet?",
      a: "Rätt på 1:a försöket: 4 poäng • 2:a försöket: 2 poäng • 3:e försöket: 1 poäng • 4:e försöket: 0 poäng (men de får gå vidare)"
    },
    {
      q: "Kan jag schemalägga en tRAT?",
      a: "Ja! Under 'Inställningar' kan du välja 'Schemalagd start' och sätta datum/tid när tRAT:en blir tillgänglig."
    },
    {
      student: true,
      q: "Vad händer om vi svarar fel?",
      a: "Ni får pröva igen! Upp till 4 försök per fråga. Varje fel försök ger färre poäng när ni till slut svarar rätt."
    },
    {
      student: true,
      q: "Ser vi varandras svar?",
      a: "Nej, men ni ser om gruppen har svarat rätt eller fel. Därför är det viktigt att diskutera innan ni väljer!"
    },
    {
      student: true,
      q: "Hur lång tid har vi på oss?",
      a: "Det beror på vad läraren satt. Vissa tRAT:er har tidsgräns (t.ex. 45 min), andra har ingen tidsgräns alls."
    },
    {
      student: true,
      q: "Vilka webbläsare fungerar?",
      a: "Chrome, Firefox, Safari, Edge - alla moderna webbläsare. Vi rekommenderar Chrome eller Firefox för bästa upplevelse."
    },
    {
      student: true,
      q: "Fungerar det på mobil?",
      a: "Ja! Både studenter och lärare kan använda mobil eller surfplatta."
    }
  ]
};

const ALL_LABELS = ["A", "B", "C", "D", "E", "F"];

export { T, FAQ, ALL_LABELS };
